// extracted by mini-css-extract-plugin
module.exports = {"SideBar":"SideBar_SideBar__3oJPE","SideBarButtonsWrapper":"SideBar_SideBarButtonsWrapper__3ZGcw","LogoContainer":"SideBar_LogoContainer__2-q4x"};